import axios from 'axios';
import * as Config from '../../config';

const state = {

};

const actions = {

    monotributista_datos_get({ commit, dispatch }, idUser) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'monotributista-datos/' + idUser)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    monotributista_datos_store({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'monotributista-datos/store', form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    monotributista_datos_get_file({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'monotributista-datos/get-file/' + form.idUser + '/' + form.idFile, {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {};

export default {
    state,
    actions,
    mutations,
};
